<app-aumico-layout [hideFooter]="true">
    <ng-container header>
        <ham-page-header [title]="pageHeader.value | i18next" [hasBackButton]="false"></ham-page-header>
    </ng-container>
    <ng-container content>
        <div style="padding: 0">
            <aumico-persons-overview
                [persons]="rows"
                [activeCount]="activeCount"
                [inactiveCount]="inactiveCount"
                [showInactive]="showInactive"
                [filter]="filter"
                [users]="users"
                [tags]="tags"
                [cpmmActive]="cpmmActive"
                (tabChange)="onTabChange($event)"
                (filterChange)="onFilterChange($event)"
                (personClick)="onPersonClick($event)"
                (newClick)="onNew()"
                (exportClick)="onExport()"
                (assigneeChange)="onAssigneeChange($event)"
                (clerkChange)="onClerkChange($event)"
                (bulkAssigneeChange)="onBulkAssigneeChange($event)"
                (bulkClerkChange)="onBulkClerkChange($event)"
                (bulkDeactivate)="onBulkDeactivate($event)"
                (bulkCreateNextFinancialYear)="onBulkCreateNextFinancialYear($event)"
            >
                <!-- REV-22155: progress of "Nächstes Geschäftsjahr" — copied from the companies overview -->
                <div belowTabs *ngIf="nextYearInProgress" class="bulk-create-progress-banner" data-testid="persons-next-year-progress">
                    <div class="progress-info">
                        <span class="ham-icon"><i class="clock-outline-icon"></i></span>
                        <span class="progress-title">{{ 'aumico_companies_bulk_create_processing' | i18next }}</span>
                        <span class="progress-count" *ngIf="nextYearJobStatus">
                            {{
                                'aumico_companies_bulk_create_processing_status'
                                    | i18next
                                        : { processed: nextYearJobStatus.processedCompanies, total: nextYearJobStatus.totalCompanies }
                            }}
                        </span>
                    </div>
                    <div class="progress-bar-container">
                        <div class="progress-bar">
                            <div class="progress-fill" [style.width.%]="nextYearProgress"></div>
                        </div>
                        <div class="progress-text">{{ nextYearProgress }}%</div>
                    </div>
                </div>
            </aumico-persons-overview>
        </div>
    </ng-container>
</app-aumico-layout>

<!-- REV-22155: "Nächstes Geschäftsjahr" — the company dialog with person data -->
<bulk-create-financial-year-modal
    data-testid="next-year-preview"
    *ngIf="nextYearPreview"
    [previewData]="nextYearPreview"
    [loading]="nextYearLoading"
    (confirm)="onNextYearConfirm()"
    (cancel)="onNextYearCancel()"
></bulk-create-financial-year-modal>
